import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import NavBar from "../../components/NavBar";
import Login from "../../root/Login";
import {Button, Card, DatePicker, Form, Input, InputNumber, Table, Tag} from "antd";
import Colors from "../../../styles/Colors";
import {BiFilter, BiPencil, BiPlus, BiReceipt, BiRefresh, BiSearch} from "react-icons/bi";
import Historials from "../../components/Historials";
import {ColumnsType, TableProps} from "antd/es/table";
import {BsEye} from "react-icons/bs";
import {GetRebuts} from "../../../dao/multilleure/administracio/GetRebuts";
import Rebut from "../../../model/multilleure/rebuts/Rebut";
import RebutModal from "../administracio/components/RebutModal";
import RebutLista from "../administracio/components/RebutLista";
import RebutFIltre from "../../../model/multilleure/rebuts/RebutFIltre";
import dayjs, {Dayjs} from 'dayjs';
import AlgoritmixModel from "../../../model/multilleure/AlgoritmixModel";
import Contacte from "../../../model/multilleure/gestioinscripcions/Contacte";
import {GetContactes} from "../../../dao/multilleure/gestioinscripcions/GetContactes";
import {GetRebutsAlgoritmix} from "../../../dao/multilleure/algoritmix/GetRebutsAlgoritmix";
import RebutAlgoritmixModal from "../administracio/components/RebutAlgoritmixModal";
import ControlHorari from "../../../model/root/ControlHorari";
import {PostControlHorari} from "../../../dao/root/PostControlHorari";
import {PostRebutAlgoritmix} from "../../../dao/multilleure/algoritmix/PostRebutAlgoritmix";

const AlgoritmixRebuts = () => {
    const titol: string = "REBUTS ALGORITMIX";

    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();

    const [coleccio, setDades] = useState<Rebut[]>([]);
    const [elementSelected, setElementSelected] = useState<Rebut>();
    const [contactes, setContactes] = useState<Contacte[]>();
    const [loading, setLoading] = useState(false);
    const [nouElement, setNouElement] = useState(false);
    const [visible, setVisible] = useState(true);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);
    const [showFilters, setShowFilters] = useState(false);
    const [rebutFiltre, setRebutFiltre] = useState<RebutFIltre>(new RebutFIltre());
    const [selected, setSelected] = useState<Rebut[]>([]);

    const [total, setTotal] = useState(0.00);
    const {RangePicker} = DatePicker;
    const moment = require('moment');

    const [options, setOptions] = useState<{ label: string; value: string; }[]>([{
        label: "",
        value: ""
    }]);

    useEffect(() => {
        handleLoadingChange(true)
        if(isLoggedIn){
            checkDades();
        }
    }, [id]);

    async function checkDades() {
        console.log("Filtres " + rebutFiltre.any + " " + rebutFiltre.idRebut);
        handleLoadingChange(true)
        const dades = await GetRebutsAlgoritmix(page, rebutFiltre);
        const contactes = await GetContactes(page);
        setDades(dades);
        setContactes(contactes);
        setContactesOptions(contactes);
        await setNameFilters(dades);
        await handleLoadingChange(false);
    }

    function toggleTable() {
        setVisible(!visible);
    }

    async function crearRebut(id: number) {
        //await DeleteRebut(id, page);
        await checkDades();
    }

    function afegirElement(element: Rebut) {
        setNouElement(!nouElement);
        setElementSelected(element);
    }

    function togleNouElement(element: Rebut) {
        setNouElement(!nouElement);
        setElementSelected(element);
    }

    async function handleCloseModal(element: Rebut, guardar: boolean) {
        setNouElement(false);
        if (guardar) {
            setLoading(true);
            await PostRebutAlgoritmix(element, page);
            await checkDades();
        }
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    function setNameFilters(elements: Rebut[]) {
        if (elements?.length > 0) {
            const uniqueNonEmptyNames = Array.from(new Set(elements
                .map((element) => element.pagador)
                .filter((name) => name !== '')));

            const ingredientNames = uniqueNonEmptyNames.map((name) => ({
                text: name,
                value: name,
            }));

            setNomFiltres(ingredientNames);
        }
    }

    function setContactesOptions (contactes : Contacte[]) {
        if (contactes && contactes?.length > 0) {
            const options = contactes.map(contact => ({
                label: `${contact.nom} ${contact.cognoms}`,
                value: contact.id +""
            }));
            console.log(options);
            setOptions(options);
        }
    }


    const columns: ColumnsType<Rebut> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            defaultSortOrder: 'descend',
            width: 5,
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
            render: (id, ele) => (
                <p>{ele.id} ({ele.key})</p>
            ),
        },
        //Nom del nen
        {
            key: 'pagador',
            title: 'Titular',
            dataIndex: 'pagador',
            width: 100,
            responsive: ['lg'],
        },
        {
            key: 'pagament',
            title: 'pagament',
            dataIndex: 'pagament',
            width: 20,
            render: (_, {pagament}) => (
                <>
                    {pagament === "RD" &&
                        <Tag color={"green"}>
                            {pagament}
                        </Tag>
                    }
                    {pagament === "TR" &&
                        <Tag color={"blue"}>
                            {pagament}
                        </Tag>
                    }
                    {pagament === "EF" &&
                        <Tag color={"red"}>
                            {pagament}
                        </Tag>
                    }
                    {pagament === "TG" &&
                        <Tag color={"orange"}>
                            {pagament}
                        </Tag>
                    }
                </>
            ),
            filterSearch: true,
            filters: [
                {
                    text: 'RD',
                    value: 'RD',
                },
                {
                    text: 'TR',
                    value: 'TR',
                },
                {
                    text: 'EF',
                    value: 'EF',
                },
                {
                    text: 'TG',
                    value: 'TG',
                },
            ],
            onFilter: (value, record) =>
                (record.estat === value),
        },
        {
            key: 'estat',
            title: 'estat',
            dataIndex: 'estat',
            width: 1,
            render: (_, {estat}) => (
                <>
                    {estat === "pagat" &&
                        <Tag color={"green"}>
                            {estat}
                        </Tag>
                    }
                    {estat === "pendent" &&
                        <Tag color={"orange"}>
                            {estat}
                        </Tag>
                    }
                    {estat === "anulat" &&
                        <Tag color={"gray"}>
                            {estat}
                        </Tag>
                    }
                    {estat === "retornat" &&
                        <Tag color={"red"}>
                            {estat}
                        </Tag>
                    }
                </>
            ),
            filterSearch: true,
            filters: [
                {
                    text: 'Pagat',
                    value: 'pagat',
                },
                {
                    text: 'Pendent',
                    value: 'pendent',
                },
                {
                    text: 'Retornat',
                    value: 'retornat',
                },
                {
                    text: 'Anulat',
                    value: 'anulat',
                },
            ],
            onFilter: (value, record) =>
                (record.estat === value),
        },
        {
            key: 'concepte',
            title: 'concepte',
            dataIndex: 'concepte',
            responsive: ['lg'],
            width: 150,
            render: (estat, ele) => (
                <div dangerouslySetInnerHTML={{__html: ele.concepte}}/>
            ),
        },
        {
            key: 'preu',
            title: 'Pagat / Preu',
            dataIndex: 'preu',
            width: 150,
            render: (_, {preu, pagat}) => (
                <>
                    <Tag color={(pagat !== preu ? "red" : "green")}>
                        {pagat}
                    </Tag> / {"  "}
                    <Tag color={(pagat !== preu ? "orange" : "green")}>
                        {preu}
                    </Tag>
                </>
            ),
            filterSearch: true,
            filters: [
                {
                    text: 'Pagat',
                    value: 'pagat',
                },
                {
                    text: 'Pendent pagament',
                    value: 'pendent pagament',
                },
            ],
            onFilter: (value, record) =>
                ((record.preu !== record.pagat ? "pendent pagament" : "pagat") === value),

        },
        {
            key: 'accions',
            title: 'Accions',
            dataIndex: 'accions',
            width: 100,
            render: (estat, ele) => (
                <>
                    <Button title={"Editar"} style={{backgroundColor: Colors.colors.color6}}
                            onClick={() => togleNouElement(ele)}><BiPencil/></Button>
                    {" "}
                    <Button title={"Crear Rebut"} style={{backgroundColor: Colors.colors.color5}}
                            onClick={() => crearRebut(ele.id)}><BiReceipt/></Button>
                </>
            ),
        },
    ];

    const tableProps: TableProps<Rebut> = {
        loading
    };

    const onChange: TableProps<Rebut>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };

    const expandedRowRender2 = (ele: Rebut) => {
        return (
            <RebutLista element={ele}/>
        );
    };

    function submit() {
        console.log("Contenido de rebutFiltre:", JSON.stringify(rebutFiltre, null, 2));
        checkDades();
    }

    const handleNumberInput = (newIdRebut: number | null, attributeName: string) => {
        const idRebut = newIdRebut || 0;
        setRebutFiltre((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: idRebut,
        }));
    };

    const handleStringInput = (event: React.ChangeEvent<HTMLInputElement>, attributeName: string) => {
        const value = event.target.value || "";  // Usar una cadena vacía si el valor es nulo
        setRebutFiltre((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: value,
        }));
    };

    type RangeValue = [Dayjs | null, Dayjs | null];

    const handleDateRangeInput = (dates: RangeValue, dateStrings: [string, string]) => {
        const startDate = dates && dates[0]?.format("DD/MM/YYYY") || "";
        const endDate = dates && dates[1]?.format("DD/MM/YYYY") || "";

        setRebutFiltre((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [dateStrings[0]]: startDate,
            [dateStrings[1]]: endDate,
        }));
    };

    const handleDateInput = (value: Dayjs | null, attributeName: string, format: string) => {
        const date = value && value.format(format) || "";

        setRebutFiltre((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: date,
        }));
    };

    function changeTotal(selectedRows: Rebut[]) {
        console.log(selectedRows);
        let tarifa = 0.0;
        selectedRows.forEach((value) => {
            tarifa += parseFloat(value.preu + "");
            //tarifa += parseFloat((value.preu * (value.quota/100)) + "");
        });
        setTotal(parseFloat(tarifa.toFixed(2)));
    }

    const rowSelection = {
        onChange: (selectedRowKeys: React.Key[], selectedRows: Rebut[]) => {
            changeTotal(selectedRows);
            setSelected(selectedRows);
        }
    };


    if (isLoggedIn) {
        return (
            <div>
                <NavBar/>
                <div className={"general"}>
                    <Card bordered={true} className={"elemento"}>
                        <div className={"actionButtons"}>
                            <Button title={"Editar"} style={{backgroundColor: Colors.colors.color2}} onClick={() =>
                                afegirElement(new Rebut)}><BiPlus/></Button>
                            <Button title={"Editar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                checkDades()}><BiRefresh/></Button>
                            <Button title={"Editar"} style={{backgroundColor: Colors.colors.color6}} onClick={() =>
                                setShowFilters(!showFilters)}><BiFilter/></Button>
                        </div>
                        {showFilters && (
                            <>
                                <br/>
                                <br/>
                                <br/>
                                <Form
                                    name="complex-form"
                                    onFinish={() => console.log("FINISH")}
                                    style={{maxWidth: 'none'}}
                                >
                                    <Form.Item style={{marginBottom: 0}}>
                                        <Form.Item
                                            name="year"
                                            style={{display: 'inline-block', width: 'calc(24% - 8px)'}}
                                        >
                                            <DatePicker picker={"year"} style={{width: "100%"}}
                                                        defaultValue={dayjs(rebutFiltre.any, "YYYY")}
                                                        onChange={(value) => handleDateInput(value, "any", "YYYY")}
                                                        placeholder="Any dels rebuts"/>
                                        </Form.Item>
                                        <Form.Item
                                            name="idRebut"
                                            style={{display: 'inline-block', width: 'calc(24% - 8px)', margin: '0 8px'}}
                                        >
                                            <InputNumber style={{width: "100%"}} placeholder="número de Rebut" min={1}
                                                         onChange={(value: number | null) => handleNumberInput(value, "idRebut")}/>
                                        </Form.Item>
                                        <Form.Item
                                            name="idremesa"
                                            style={{display: 'inline-block', width: 'calc(24% - 8px)', margin: '0 8px'}}
                                        >
                                            <InputNumber style={{width: "100%"}} placeholder="número de remesa" min={1}
                                                         onChange={(value: number | null) => handleNumberInput(value, "idRemesa")}/>
                                        </Form.Item>
                                        <Form.Item
                                            name="pagador"
                                            style={{display: 'inline-block', width: 'calc(24% - 8px)', margin: '0 8px'}}
                                        >
                                            <Input style={{width: "100%"}} placeholder="Nom Titular"
                                                   onChange={(value) => handleStringInput(value, "nomPagador")}/>
                                        </Form.Item>
                                    </Form.Item>
                                    <Form.Item style={{marginBottom: 0}}>
                                        <Form.Item
                                            name="dates"
                                            style={{display: 'inline-block', width: 'calc(42% - 8px)', margin: '0 8px'}}
                                        >
                                            <DatePicker.RangePicker
                                                style={{width: "100%"}}
                                                placeholder={["rebuts de la data", "fins la data"]}
                                                format="DD/MM/YYYY"
                                                onChange={() => handleDateRangeInput}
                                            />
                                        </Form.Item>
                                        <Form.Item label={"  "}
                                                   name="button"
                                                   style={{display: 'inline-block', width: 'calc(10% - 8px)'}}
                                        >
                                            <Button title="Buscar" style={{backgroundColor: Colors.colors.color6}}
                                                    onClick={() => submit()}><BiSearch/></Button>
                                        </Form.Item>
                                    </Form.Item>
                                </Form>
                            </>
                        )}
                        <h4 className={"titol"}>{titol}</h4>
                        {visible && (
                            <Table
                                {...tableProps}
                                onChange={onChange}
                                columns={columns}
                                expandable={{
                                    expandedRowRender: (record) =>
                                        expandedRowRender2(record),
                                    rowExpandable: (record) => true,

                                }}
                                dataSource={coleccio}
                                rowSelection={{
                                    type: 'checkbox',
                                    ...rowSelection,
                                }}
                            />
                        )}

                        <p>Preu total: {parseFloat(total.toFixed(2))} eur</p>
                    </Card>
                    <br/>
                    <Historials pantalla={"REBUTALGORITMIX"} pagina={page}/>
                    {nouElement && (
                        <RebutAlgoritmixModal element={elementSelected} onClose={handleCloseModal} visible={nouElement}
                                    handleSubmit={() => console.log("submit")} checkData={checkDades} options={options}
                                    contactes={contactes}
                        />
                    )}
                </div>
            </div>
        );
    } else {
        return (
            <Login/>
        );
    }
};
export default AlgoritmixRebuts;
